import { render, staticRenderFns } from "./coreSpacer.vue?vue&type=template&id=17be519e"
import script from "./coreSpacer.vue?vue&type=script&lang=js"
export * from "./coreSpacer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports